import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { Api } from '@core/api/Api';
import type { AppConfig } from '@core/environment/tokens';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const initializeApp = async () => {
  const config = await fetch(Api.Config, {
    headers: {
      Accept: 'application/json',
    },
  }).then((res): Promise<AppConfig> => res?.json());

  await bootstrapApplication(AppComponent, appConfig(config));
};

initializeApp().catch((error) =>
  console.error(
    `Failed to initialize the application. ${error.message || error}`,
  ),
);
